var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValuesIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 148,
    viewBox: "33 9 100 148",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.0006 58.248C96.596 58.248 107.618 47.2236 107.618 33.624C107.618 20.0245 96.5981 9 83.0006 9C69.4031 9 58.3828 20.0245 58.3828 33.624C58.3828 47.2236 69.4052 58.248 83.0006 58.248Z",
    fill: "#FABBAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7599 156.736H132.244C132.244 130.431 111.62 108.947 85.6639 107.565H132.241C132.241 80.3676 110.197 58.3207 83.0017 58.3207V58.248C83.0017 58.248 83.0017 58.248 82.9996 58.248C55.8047 58.248 33.7578 80.2949 33.7578 107.492H82.9996C55.8047 107.492 33.7599 129.541 33.7599 156.736Z",
    fill: "#C97F42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132 157C132 129.938 110.061 108 83 108C55.9386 108 34 129.938 34 157H132Z",
    fill: "#FF794E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuesIcon1);
export default __webpack_public_path__ + "static/media/values_icon1.4a6e84ace1dcba52e8ccb82404f8f946.svg";
export { ForwardRef as ReactComponent };